import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { IconUsers, IconBuilding } from "@tabler/icons-react";
import UserList from "./UserList";
import { DepartmentList } from "./Department";
import "./UsersPage.css";

const UsersPage = (props) => {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="users-page-container">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="users-page-tabs mb-0"
      >
        <Tab
          eventKey="users"
          title={
            <span className="users-tab-title">
              <IconUsers size={18} className="me-2" />
              Usuários
            </span>
          }
        >
          <UserList {...props} />
        </Tab>
        <Tab
          eventKey="departments"
          title={
            <span className="users-tab-title">
              <IconBuilding size={18} className="me-2" />
              Departamentos
            </span>
          }
        >
          <DepartmentList />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UsersPage;
